import { fetchIndustries } from "../services/industryAPI";
import { useEffect, useState } from 'react';

const watchlistCache = {};

const CACHE_TTL_MS = 60000;

export function useIndustries(user, riskSource, idioRisks) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!user) return;

        const userId = user.uid;
        const cacheKey = `${userId}::${riskSource}`;
        const now = Date.now();

        const cacheForUser = watchlistCache[cacheKey];

        if (cacheForUser && now - cacheForUser.timestamp < CACHE_TTL_MS) {
            setData(cacheForUser.data);
            return;
        }

        setLoading(true);

        fetchIndustries(userId, riskSource, idioRisks)
            .then((rows) => {
                setData(rows);
                setError('');

                watchlistCache[cacheKey] = { data: rows, timestamp: Date.now() };
            })
            .catch((err) => {
                setError(err.message || 'Failed to fetch industries');
            })
            .finally(() => setLoading(false));
    }, [user]);

    return { data, loading, error };
}

export function clearUserWatchlistCache(uid) {
    if (uid && watchlistCache[uid]) {
        delete watchlistCache[uid];
    }
}